<div class="case-actions-container" role="region" aria-labelledby="case-actions-heading">
  <!-- Header Row -->
  <div class="actions-header">
    <div class="header-center">
      <span class="header-title" id="case-actions-heading">Case Actions</span>
      @if (selectedCase()) {
      <span class="badge badge-blue" role="status">Case #{{selectedCase()?.caseNo}}</span>
      }
    </div>
  </div>

  <!-- Form Body -->
  <div class="actions-body">
    @if (selectedCase()) {
    <form class="actions-form" aria-label="Case action form">
      <!-- Row 1: Action, Route To, Date -->
      <div class="form-field-row flex-row">
        <div class="form-field col-action">
          <div class="field-label-row">
            <label id="action-label" for="action-select">
              Action <span class="required-mark" aria-hidden="true">*</span>
            </label>
            <app-warning-tooltip [message]="tooltipTexts.searchHint"
              [showInfoIcon]="true" appearance="suggestion" />
          </div>
          <div>
            <app-searchable-select id="action-select" [items]="lookUpService.actionSearch.data()" bindLabel="actionDesc"
              bindValue="actionCode" placeholder="Select Action" [model]="actionService.selectedAction()"
              [loadingMore]="lookUpService.actionSearch.loadingMore()"
              (modelChange)="onActionChange($event)" (search)="onActionSearchChange($event)"
              (scrollToEnd)="onActionScrollToEnd()"
              aria-labelledby="action-label" aria-required="true" tabindex="0">
            </app-searchable-select>
          </div>

          @if (actionService.selectedPeopleForAction().length > 0) {
          <div class="person-status-row">
            <button type="button" class="person-icon-badge" (click)="openPersonModal()"
              aria-label="Show {{ actionService.selectedPeopleForAction().length }} selected person(s) for this action"
              [attr.title]="tooltipTexts.showSelectedPeople" tabindex="0">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                aria-hidden="true" focusable="false">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </button>
            <span class="assigned-pill" id="person-count-status">
              Person: {{ actionService.selectedPeopleForAction().length }}
            </span>
          </div>
          }

          @if (actionService.selectedAction() && actionService.selectedPeopleForAction().length === 0) {
          <div class="person-status-row person-status-row--danger" role="alert" aria-live="assertive">
            <button type="button" class="person-icon-badge person-icon-badge--danger" (click)="openPersonModal()"
              aria-label="Select a person to proceed with this action" [attr.title]="tooltipTexts.selectPerson" tabindex="0">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                aria-hidden="true" focusable="false">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </button>
            <span class="assigned-pill assigned-pill--danger">Kindly select a person to proceed</span>
          </div>
          }
        </div>

        <div class="form-field col-route">
          <div class="field-label-row">
            <label id="route-to-label" for="route-to-select">Route To</label>
            <app-warning-tooltip [message]="tooltipTexts.searchHint"
              [showInfoIcon]="true" appearance="suggestion" />
          </div>
          <app-searchable-select id="route-to-select" [items]="lookUpService.inspectorSearch.data()" bindLabel="name"
            bindValue="userId" placeholder="Select User" [model]="actionService.routeTo()"
            [loadingMore]="lookUpService.inspectorSearch.loadingMore()"
            (modelChange)="actionService.setRouteTo($event)" (search)="onInspectorSearch($event)"
            (scrollToEnd)="onInspectorScrollToEnd()"
            aria-labelledby="route-to-label" tabindex="0">
          </app-searchable-select>
        </div>

        <div class="form-field col-date">
          <label id="action-date-label" for="action-date-picker">
            Date <span class="required-mark" aria-hidden="true">*</span>

          </label>
          <app-date-picker id="action-date-picker" placeholder="MM/DD/YYYY hh:mm A" [model]="actionService.actionDate()"
            (modelChange)="actionService.setActionDate($event)" aria-labelledby="action-date-label" aria-required="true"
            tabindex="0">
          </app-date-picker>
        </div>
      </div>

      <!-- Row 2: Comments -->
      <div class="form-field full-width">
        <label for="action-comments">Comments</label>
        <textarea id="action-comments" rows="4" placeholder="Enter comments here..." [maxlength]="500"
          [ngModel]="actionService.comments()" (ngModelChange)="actionService.setComments($event)" name="comments"
          aria-label="Comments" tabindex="0">
        </textarea>
        <app-char-counter [text]="actionService.comments()" [maxLength]="500">
        </app-char-counter>
      </div>
    </form>
    } @else {
    <div class="no-case-state" role="status" aria-live="polite">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5" aria-hidden="true"
        focusable="false">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
      </svg>
      <p>Select a case from the Search Results to view actions.</p>
    </div>
    }
  </div>

  <!-- Footer Action Row -->
  <div class="actions-footer">
    <button class="btn btn-create" (click)="createLetter()" [disabled]="!canCreateLetter()"
      [attr.aria-disabled]="!canCreateLetter()" aria-label="Create Letter" type="button" tabindex="0">
      Create Letter
    </button>
    <button class="btn btn-secondary" (click)="reset()" aria-label="Reset form" type="button" tabindex="0">
      <span class="btn-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          aria-hidden="true" focusable="false">
          <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"></path>
        </svg>
      </span>
      Reset
    </button>
  </div>
</div>

@if (showPersonModal) {
<app-person-modal role="dialog" aria-modal="true" aria-label="Manage persons for case {{ selectedCase()?.caseNo }}"
  [caseId]="selectedCase()?.caseNo || ''"
  [preSelectedPeople]="actionService.selectedPeopleForAction()"
  (closed)="onPersonModalClosed($event)">
</app-person-modal>
}